/* eslint-disable no-console */
import { WrapColorPicker } from './styles';

const ColorPicker = ({ onFormSelectColor, onClose, colors }) => {
  /**
   * Submete formulário com a cor selecionada
   */
  const onSelectFontColor = (color) => {
    onFormSelectColor && onFormSelectColor(color);
    onClose && onClose();
  };

  return (
    <WrapColorPicker>
      <div className="style-list">
        {colors.map((row, iRow) => {
          return (
            <div
              key={iRow}
              className={`style-item`}
              onClick={() => onSelectFontColor(row)}
            >
              <svg
                key="1"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M 0.1386 0.1386 H 20 V 20 H 0.1386 V 0.1386 Z"
                  fill={row}
                  fillOpacity="0.2"
                  fillRule="evenodd"
                  stroke={row}
                  strokeWidth="3"
                  strokeOpacity="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          );
        })}
      </div>
    </WrapColorPicker>
  );
};

ColorPicker.properties = {
  ignore: true,
};

export default ColorPicker;
